import { defineComponent } from 'vue';

export type Component<T extends any = any> =
  | ReturnType<typeof defineComponent>
  | (() => Promise<typeof import('*.vue')>)
  | (() => Promise<T>);

  //页面按扭级权限
export interface RouterRule{
  see:{type:number,default:1};
  creating:{type:number,default:1};
  edit:{type:number,default:1};
  del:{type:number,default:1};
  agent:{type:number,default:1};
}
export const DefaultRule=():RouterRule=>{
  return {see:1,creating:1,edit:1,del:1,agent:1} as RouterRule
}

export interface RouterMeta {
  title: string;
  keepAlive?: boolean;
  icon?: any;
  permission?: Array<string>;
  target?: string;
  hidden?: boolean;
  hiddenHeaderContent?: boolean;
  hideHeader?: boolean;
  blank?: boolean;
  rule?:RouterRule;
}

export interface Router {
  name: string;
  path: string;
  redirect?: string
  meta?: RouterMeta;
  component?: Component | string;
  children?: Router[];
  hidden?: boolean;
  hideChildrenInMenu?: boolean;
}
